import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CookieBannerComponent } from './shared/cookie-banner/cookie-banner.component';

import { HomeComponent } from './home/home.component';
import { BlogModule } from './blog/blog.module'; 
import { PrivacyModule } from './privacy/privacy.module'; 
import { Four04Component } from './404/four04.component';

const routes: Routes = [
  { path: '', component: CookieBannerComponent, outlet: 'cookie' },
  { path: '', component: HomeComponent },
  { path: '**', component: Four04Component }
];

@NgModule({
  imports: [
    BlogModule,
    PrivacyModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { }
